exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".giftee-app-icon[data-v-e8947d1e] {\n  max-width: 100%;\n}\n", ""]);
